import { render, staticRenderFns } from "./ShiftType.vue?vue&type=template&id=f57490b4"
import script from "./ShiftType.vue?vue&type=script&lang=js"
export * from "./ShiftType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports